<div class="tn-footer footer-fixed-position">
    <footer id="footer">
        <!--<div id="footer-top">
            <a href="#" class="starball"><img src="https://tn.gov/etc/clientlibs/tncore/main/img/footer-starball.png" alt="Tristar" width="100%" /></a>
        </div>-->
        <div id="footer-bottom">
            <div class="row">
                <div class="large-12 medium-12 columns">
                    <ul class="inline-list">
                        <li><a href="https://tn.gov" class="first">TN.gov</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</div>